import React from 'react';
import HtmlHead from '../../components/01_atoms/HtmlHead';
import BasketPage from '../../componentsGifts/BasketPage';

import '../../styles/gifts/sass/theme.scss';

const Basket = () => {
  return (
    <div>
      <HtmlHead
        metatags={[
          {
            tag: 'meta',
            attributes: { content: 'Your shopping basket | Concern Gifts', name: 'title' },
          },
        ]}
        pageTitle="Your shopping basket"
      />

      {/*<Paragraphs blocks={blocks} />*/}
      <BasketPage />
    </div>
  );
};

export default Basket;
